import { apiSlice } from "../../app/api/apiSlice"

export const bobApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        saveBobForm: builder.mutation({
            query: (request) => ({
                url: `/bob/save`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        getBobForm: builder.mutation({
            query: advisorId => ({
                url: `/bob/getForm/${advisorId}`,
                method: 'GET'
            })
        }),
        getBobFormId: builder.mutation({
            query: advisorId => ({
                url: `/bob/getFormId/${advisorId}`,
                method: 'GET'
            })
        }),
    })
})

export const {
    useSaveBobFormMutation,
    useGetBobFormMutation,
    useGetBobFormIdMutation
} = bobApiSlice